import * as v from 'valibot';
import { sunSchema } from '../types/Sun';
import { timeSchema } from '../types/Time';
export const scheduleTimeSchema = v.variant('kind', [
    v.object({ kind: v.literal('cron'), cron: v.string() }),
    v.object({ kind: v.literal('time'), time: timeSchema }),
    v.object({ kind: v.literal('sun'), sun: sunSchema }),
]);
